export const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

/** `2026-09-15` → `15/09/2026`. Empty / invalid → `''`. */
export function formatIsoDayFr(iso: string): string {
  if (!ISO_DAY.test(iso)) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}

function isRealIsoDay(y: number, m: number, d: number): boolean {
  if (m < 1 || m > 12 || d < 1 || d > 31) return false;
  const dt = new Date(Date.UTC(y, m - 1, d));
  return dt.getUTCFullYear() === y && dt.getUTCMonth() === m - 1 && dt.getUTCDate() === d;
}

/** `15/09/2026`, `15.09.2026`, `2026-09-15` → ISO day or null. */
export function parseFrDay(raw: string): string | null {
  const t = raw.trim();
  if (t.length === 0) return null;
  if (ISO_DAY.test(t)) {
    const [ys, ms, ds] = t.split('-');
    const y = Number(ys);
    const m = Number(ms);
    const d = Number(ds);
    return isRealIsoDay(y, m, d) ? t : null;
  }
  const match = t.match(/^(\d{1,2})[/.](\d{1,2})[/.](\d{4})$/);
  if (!match) return null;
  const d = Number(match[1]);
  const m = Number(match[2]);
  const y = Number(match[3]);
  if (!isRealIsoDay(y, m, d)) return null;
  return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}
